// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

// ===== Interfaces =====

import {
    IUpdatePostResult,
}                               from '../interfaces';

const updatePost = async ({
    test,
    postId,
    title,
    subtitle,
    description,
    imagePath,
}: {
    test: boolean,
    postId: string,
    title?: string,
    subtitle?: string,
    description?: string,
    imagePath?: string,
}): Promise<IUpdatePostResult> => {
    const functions = getFunctions();
    const handleUpdatePost = httpsCallable<
        Record<
            string,
            boolean | string | undefined
        >,
        IUpdatePostResult
    >(
        functions,
        'updatePost',
    );
    const payload = {
        test,
        postId,
        title,
        subtitle,
        description,
        imagePath,
    };
    const executeUpdate = async (): Promise<IUpdatePostResult> => {
        const result = await handleUpdatePost(payload);
        return result.data as IUpdatePostResult;
    };

    return executeUpdate();
};

export default updatePost;
